import { selectIsFetching as selectIsFetchingDetail } from './state/detail/selector'
import { selectIsFetching as selectIsFetchingSearch } from './state/search/selector'


export default {
    action: {},
    selector: {
        selectIsFetching: (state) => {
            return selectIsFetchingDetail(state) || selectIsFetchingSearch(state)
        },
    },
}




// WEBPACK FOOTER //
// ./src/modules/prospect/index.js